module.exports = __webpack_public_path__ + "img/u1.c371503e.jpg";